export const reloadAlbum = () => ({
    type: "RELOAD_ALBUM"
});

export const reloadPlaylist = () => ({
    type: "RELOAD_PLAYLIST"
});